import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";

import { routeEnum } from "@enums/route.enum";
import { RootState } from "@store/index";

export default function RequireAuth({
  HomeRoute = routeEnum.Home,
}: {
  HomeRoute?: string;
}) {
  const { isAuthenticated } = useSelector((s: RootState) => s.local);
  return isAuthenticated ? <Outlet /> : <Navigate to={HomeRoute} replace />;
}
